import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Row, Col } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import CurrencyConverter from '../../CurrencyConverter';
import messages from '../../../locale/messages';

import userIcon from '/public/Icons/automobile-with-wrench.svg';
import serviceIcon from '/public/Icons/user.svg';
import bookingIcon from '/public/Icons/bookingIcon.svg';
import moneyIcon from '/public/Icons/money.svg';

import s from './AdminDashboard.css';

const DashboardBox = ({ icon, title, data, isCurrency, currency, id }) => (
  <div className={cx(s.box)}>
    <div className={cx(s.boxBg)}>
      <div className={s.sectionOne}>
        <svg className={cx(s.overviewIcon, 'overviewIconRTL', 'svgImg')}>
          <use xlinkHref={`${icon}#Layer_${id}`}></use>
        </svg>
        <h2 className={s.fontCss}><FormattedMessage {...title} /></h2>
      </div>
      <div className={s.boxInner}>
        <div className={s.displayGrid}>
          {['today', 'weekly', 'montly'].map((period) => (
            <div key={period}>
              <div><FormattedMessage {...messages[period]} /></div>
              <div className={s.priceCircle}>
                {isCurrency
                  ? <CurrencyConverter from={currency} amount={data[period]} />
                  : data[period]}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    <div className={cx(s.totalCss)}>
      <div className={s.textCenterDashboard}>
        <FormattedMessage {...messages.overAll} /> -{' '}
        {isCurrency
          ? <CurrencyConverter from={currency} amount={data.overall} />
          : data.overall}
      </div>
    </div>
  </div>
);

DashboardBox.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  isCurrency: PropTypes.bool,
  currency: PropTypes.string
};

const AdminDashboard = ({ getDashboardCount, todayEarnings, weeklyEarnings, monthlyEarnings, totalEarnings }) => {
  const {
    totalPartnersCount = 0, todayPartnersCount = 0, weekPartnersCount = 0, monthPartnersCount = 0,
    totalUsersCount = 0, todayUsersCount = 0, weekUsersCount = 0, monthUsersCount = 0,
    totalBookingsCount = 0, todayBookingsCount = 0, weekBookingsCount = 0, monthBookingsCount = 0,
    currency
  } = getDashboardCount?.result || {};

  return (
    <Row>
      <Col xl={4} lg={6} md={12} sm={12} xs={12}>
        <DashboardBox
          icon={serviceIcon}
          id={2}
          title={messages.users}
          data={{
            today: todayUsersCount,
            weekly: weekUsersCount,
            montly: monthUsersCount,
            overall: totalUsersCount
          }}
        />
      </Col>
      <Col xl={4} lg={6} md={12} sm={12} xs={12}>
        <DashboardBox
          icon={userIcon}
          id={1}
          title={messages.partners}
          data={{
            today: todayPartnersCount,
            weekly: weekPartnersCount,
            montly: monthPartnersCount,
            overall: totalPartnersCount
          }}
        />
      </Col>
      <Col xl={4} lg={6} md={12} sm={12} xs={12}>
        <DashboardBox
          icon={bookingIcon}
          id={3}
          title={messages.bookings}
          data={{
            today: todayBookingsCount,
            weekly: weekBookingsCount,
            montly: monthBookingsCount,
            overall: totalBookingsCount
          }}
        />
      </Col>
      <Col xl={4} lg={6} md={12} sm={12} xs={12} className='marginAuto'>
        <DashboardBox
          icon={moneyIcon}
          id={4}
          title={messages.totalEarnings}
          isCurrency
          currency={currency}
          data={{
            today: todayEarnings,
            weekly: weeklyEarnings,
            montly: monthlyEarnings,
            overall: totalEarnings
          }}
        />
      </Col>
    </Row>
  );
};

AdminDashboard.propTypes = {
  getDashboardCount: PropTypes.object,
  todayEarnings: PropTypes.number,
  weeklyEarnings: PropTypes.number,
  monthlyEarnings: PropTypes.number,
  totalEarnings: PropTypes.number
};

export default withStyles(s)(AdminDashboard);
